import React from 'react';
import { Query, Mutation } from '@apollo/client/react/components';

import CurrentUserQuery from 'buyside/graphql/queries/CompensationSubmissionCurrentUser.graphql';
import CreateCompensationMutation from 'buyside/graphql/mutations/CreateCompensation.graphql';
import UpdateCompensationMutation from 'buyside/graphql/mutations/UpdateCompensation.graphql';
import DestroyCompensationMutation from 'buyside/graphql/mutations/DestroyCompensation.graphql';

import CompensationSubmissionPage from 'buyside/components/presentation/CompensationSubmissionPage/compensationSubmissionPage';

const CompensationSubmissionContainer = () => {
  return (
    <Query query={CurrentUserQuery}>
      {({ loading: currentUserLoading, error: userError, data = {} }) => {
        return (
          <Mutation mutation={CreateCompensationMutation}>
            {mutate => {
              const createCompensation = args => mutate({ variables: args });
              return (
                <Mutation mutation={UpdateCompensationMutation}>
                  {mutate => {
                    const updateCompensation = args => mutate({ variables: args });
                    return (
                      <Mutation mutation={DestroyCompensationMutation}>
                        {mutate => {
                          const destroyCompensation = id => mutate({ variables: { id } });
                          return (
                            <CompensationSubmissionPage
                              currentUserLoading={currentUserLoading}
                              userError={userError}
                              currentUser={data.currentUser}
                              createCompensation={createCompensation}
                              updateCompensation={updateCompensation}
                              destroyCompensation={destroyCompensation}
                            />
                          );
                        }}
                      </Mutation>
                    );
                  }}
                </Mutation>
              );
            }}
          </Mutation>
        );
      }}
    </Query>
  );
};

export default CompensationSubmissionContainer;
